import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'navy' | 'accent' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'silver-metal border border-white/70 text-blue-950 shadow-lg shadow-black/30 hover:brightness-110',
    navy: 'bg-blue-900 text-white shadow-lg hover:bg-blue-800',
    accent: 'bg-blue-700 text-white shadow-lg hover:bg-blue-600',
    outline: 'border-2 border-slate-300 bg-transparent text-slate-100 hover:bg-slate-200 hover:text-blue-950'
  };
  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-4 text-sm sm:px-8 sm:text-base'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-extrabold uppercase tracking-wide transition-[background-color,filter,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-slate-300/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={classes} aria-label={ariaLabel} data-id="element-261" data-mp="opwy9ilb1mrf">
        {children}
        {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-262" data-mp="xoic50fu0dlv" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-263" data-mp="1cdeuprfil90q">
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-264" data-mp="17elcxmt72vur" />}
    </button>;
}